import {Component, createRef} from 'react';
import {Button} from "reactstrap"
import Draggable from 'react-draggable';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import '../../css/styles.css';
import getCurrentDateTime from '../../objects/CommonUse/get_current_date_time';
import Config from '../../config';
import {buildUrl} from '../../objects/CommonUse/build_URL';

class CommentModal extends Component {
            constructor(props) {
              super(props);
              this.gameInfo = this.props.gameInfo();
              this.thumbsUpSave = this.thumbsUpSave.bind(this);
              this.thumbsSidewaysSave = this.thumbsSidewaysSave.bind(this);
              this.thumbsDownSave = this.thumbsDownSave.bind(this);
              this.state={
                thumbsUpIcon: "./assets/thumbsUp.jpg",
                thumbsSidewaysIcon: "./assets/thumbsSideways.jpg",
                thumbsDownIcon: "./assets/thumbsDown.jpg",
                thumbsChosen: "noThumbChoice",
                headers: setHeadersForFetch(),
                triggerRender: false,
                subProcess: "CommentModal",
                environment: Config.dataURL.currentEnv,
              }
             this.nodeRef = createRef(); 
    }

        
    render() {
  
    return <>
        <div className="modal-overlay"></div>
        <Draggable handle=".modal-header" nodeRef={this.nodeRef}>
            <div className="custom-modal modal-with-rounded-corners" ref={this.nodeRef}>
            <div className="modal-content">
                <div className="modal-header d-flex 
                    justify-content-between align-items-center">
                    <h4>Submit a Game Comment</h4>
                    <Button outline color="primary" 
                        onClick={() => this.props.onClose()}
                         onTouchEnd={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                this.props.onClose();
                            }}
                          >
                        Close
                    </Button>
                </div>
                <div className="modal-body">
                    <div>
                        <h5>You can review comments that you have submitted and 
                            the reply from administrators by going to the "Contact Us"
                            link (top right of page) and clicking the "Review My Game Comments"
                            button.
                        </h5>
                        {this.state.thumbsChosen === "thumbsUp" ?
                            <img src={this.state.thumbsUpIcon} 
                                className="thumbsUp-position thumbs-img" alt="thumbsUp"
                                />
                        :
                            <img src={this.state.thumbsUpIcon} 
                                className="thumbsUp-position thumbs-img buttonDisabledImage" alt="thumbsUp"
                                onClick={this.thumbsUpSave}/>
                        }
                        {this.state.thumbsChosen === "thumbsSideways" ?
                            <img src={this.state.thumbsSidewaysIcon} 
                                className="thumbsSideways-position thumbs-img" alt="thumbsSideways"
                                />
                        :
                            <img src={this.state.thumbsSidewaysIcon} 
                                className="thumbsSideways-position thumbs-img buttonDisabledImage" alt="thumbsSideways"
                                onClick={this.thumbsSidewaysSave}/>
                        }
                        {this.state.thumbsChosen === "thumbsDown" ?
                            <img src={this.state.thumbsDownIcon} 
                                className="thumbsDown-position thumbs-img" alt="thumbsDown"
                            />
                        :
                            <img src={this.state.thumbsDownIcon} 
                                className="thumbsDown-position thumbs-img buttonDisabledImage" alt="thumbsDown"
                                onClick={this.thumbsDownSave}/>
                        }
                    </div>
                    <div className="form-group mt-4">
                        <label className="font-weight-bold" htmlFor="comment">Comment:</label>
                        <textarea className="form-control" rows="5" id="comment"></textarea>
                    </div>
                    <div>
                        <b> Note:</b>  You can drag this comment box up, down, right, or left.
                    </div>
        
            </div>
            <div className="modal-footer p-0 ">
                <div className="mx-4 text-danger">{this.errorMessage}</div>
                <Button variant="primary"  className="mr-4" onClick={() => this.checkThumbsChosen()}>
                      Submit
                </Button>
            </div>
            </div>
        </div>
        </Draggable>
      
        </>
    }

thumbsUpSave(){
    this.setState({thumbsChosen: "thumbsUp"});
}

thumbsSidewaysSave(){
    this.setState({thumbsChosen: "thumbsSideways"});
}

thumbsDownSave(){
    this.setState({thumbsChosen: "thumbsDown"});
}

checkThumbsChosen(){
    if (this.state.thumbsChosen === "noThumbChoice"){
        this.errorMessage = "Click on the green thumbsUp (this is something I like about this game), " +
        "thumbsSideways (I have an idea for a change) or red thumbsDown (this is something I don't " +
        "like about this game) then click submit again.";
        this.setState({thumbsChosen: "noThumbChoice"});

    }else{
        this.errorMessage = "";
        this.submitGameComment();
    }
}

submitGameComment(){
    this.comment = document.getElementById("comment").value;
    let subProcess = sessionStorage.getItem("GameViewSubProcess");
    if (!subProcess){
        subProcess = "NoSubProcess";
    }
    let username = sessionStorage.getItem("username");
    if (this.comment === ""){
        this.comment = "No Comment";
    }
    let btnText = "noButtonSelected";
    let currentCardTitle = "NoCurrentCard";
    let currentCardDescription = "NoCurrentCard";
    let additionalData = {text: "noAdditionalData"};
    if (this.gameInfo.currentCard && this.props.gamePart === "GameView" &&
        this.gameInfo.currentCard.title){
        subProcess = this.gameInfo.currentCard.cardType;
        currentCardTitle = this.gameInfo.currentCard.title;
        currentCardDescription = this.gameInfo.currentCard.description;
        if (!this.props.btnText || this.props.btnText === ""){
            //  no button text set 
       }else{
            btnText = this.props.btnText;
       }
       if (this.gameInfo.currentCard.friendName){
            additionalData = {friendName: this.gameInfo.currentCard.friendName};
       }
    }
    if (this.props.gamePart === "Activities") { 
        if (!this.gameInfo.slctActivity.activityName){
            currentCardTitle = "No Activity Selected";
        }else{
            currentCardTitle = this.gameInfo.slctActivity.activityName;
        }
        if (this.gameInfo.friendInfo.friendName && this.gameInfo.friendInfo.friendName !== ""){
            currentCardDescription = this.gameInfo.friendInfo.friendName;
        }
        let score = "";
        if (this.gameInfo.activityScore){
              score = this.gameInfo.activityScore;
        }
        let level = "";
        if (this.gameInfo.levelInfo){
              level = this.gameInfo.levelInfo;
        }
        additionalData = {score: score,  level: level};
    }
    let currentDateTime = getCurrentDateTime();
    this.playerFeedback = {thumbsChosen: this.state.thumbsChosen, comment: this.comment, 
        gamePart: this.props.gamePart, process: this.props.processName,  subProcess: subProcess,
        user: username, cardTitle: currentCardTitle, description: currentCardDescription, btnText: btnText, 
        additionalData: additionalData, dateAdded: currentDateTime.date, timeAdded: currentDateTime.time };
    this.savePlayerFeedback();
    this.setState({triggerRender: true});
    this.props.onClose();
}

savePlayerFeedback() {
    const funcName = "savePlayerFeedback";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {
        method:'post',
        headers: this.state.headers,
        body: JSON.stringify(this.playerFeedback)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                       //  comment successfully updated
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: this.playerFeedback};
                        this.props.processError(errorObj);
                    }
            });
        };
    });
}

}

export default CommentModal;